// Upper bound on the columns we build from / pad a table to. Real spreadsheet pastes are far under this;
// the cap stops a crafted `colspan`/`rowspan` from inflating the grid into a client-side DoS. Shared by
// the deserializer (which builds the grid) and the table normalization plugin (which pads ragged rows)
// so the two bounds can't drift apart.
export const MAX_TABLE_COLUMNS = 64;
